import { useNavigate } from "react-router-dom";
import { C } from "@coremonit/design-system";
import { ChevronRight } from "lucide-react";

export interface Crumb {
  label: string;
  path?: string;
}

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  const nav = useNavigate();
  return (
    <nav style={{ display: "flex", alignItems: "center", gap: 4, flexWrap: "wrap", marginBottom: 4 }}>
      {items.map((c, i) => (
        <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
          {i > 0 && <ChevronRight size={11} color={C.textMuted} />}
          {c.path ? (
            <button
              onClick={() => nav(c.path!)}
              style={{ background: "transparent", border: "none", color: i === items.length - 1 ? C.text : C.blue, cursor: "pointer", fontSize: 11, fontWeight: i === items.length - 1 ? 700 : 500, padding: 0 }}
            >
              {c.label}
            </button>
          ) : (
            <span style={{ color: C.text, fontSize: 11, fontWeight: 700 }}>{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
